import React from 'react';
import SvgIcon from './SvgIcon';

const MaritimeAccident = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M.5 23.429c2.451.521 4.5-2 4.5-2a4.282 4.282 0 003.493 1.979A4.115 4.115 0 0012 21.429a4.078 4.078 0 003.493 1.979A4.32 4.32 0 0019 21.429s2.049 2.521 4.5 2M12.493 18.5V9.393M22.993 11.393l-10.5-2-10.5 2M21.982 11.2l-2.22 8.868M3.004 11.2l2.005 8.132"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.493 10.535V7.518a2.006 2.006 0 00-2-2h-8a2.006 2.006 0 00-2 2v3.017M14.993 7.5h-5M14.493 5.5V1a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v4.5M14.493 3.5h-4M21.177 14.467l-8.684-2.074-8.649 2.052"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

MaritimeAccident.displayName = 'MaritimeAccidentIcon';

export default MaritimeAccident;
